import { render, staticRenderFns } from "./SocialLinksSection.vue?vue&type=template&id=723b4a86&scoped=true"
var script = {}
import style0 from "./SocialLinksSection.vue?vue&type=style&index=0&id=723b4a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723b4a86",
  null
  
)

export default component.exports